import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadSymbolPriceListEpic } from './_epics/loadSymbolPriceList.epic';
import { exportSymbolPricesEpic } from './_epics/exportSymbolPrices.epic';

export const symbolPriceEpic = safeCombineEpics(loadSymbolPriceListEpic, exportSymbolPricesEpic);
